import PropTypes from 'prop-types';

import { GC_AND_PROMO_CONSTRAINTS } from 'constants/constraintViolations';

import ErrorList from 'components/checkout/caap/ErrorList';
import { ExpandLess, ExpandMore } from 'components/icons';
import { TextField } from 'components/Mdl';
import { rightArrow as styleRightArrow } from 'styles/components/checkout/caap/rightArrow.scss';
import { getFieldFocusEvents } from 'helpers/CheckoutUtils';
import { Row, RowSpan } from 'components/checkout/caap/Layout';
import css from 'styles/components/checkout/caap/giftCardContainer.scss';

const textfieldFocusEvents = getFieldFocusEvents(css.hasFormElementWithFocus);

const GiftCardContainer = ({ code, constraintViolations = {}, isFetchingCheckoutData, onGiftCardVerify, onGiftCardChange, onToggleGiftCardModalClick, showGiftCardModal, withOffset }, { testId }) => {
  let errorList = [];

  Object.keys(constraintViolations).forEach(key => {
    if (GC_AND_PROMO_CONSTRAINTS.includes(key)) {
      errorList = [...errorList, constraintViolations[key].message];
    }
  });

  // ACCESSIBILITY ISSUE Disable lint, fix in GitHub Issue #3833
  /* eslint-disable jsx-a11y/click-events-have-key-events */
  return (
    <div>

      <Row mobileOnly={true} extraClass={css.toggleRow}>
        <h4
          role="link" // eslint-disable-line jsx-a11y/no-noninteractive-element-to-interactive-role
          tabIndex="0"
          onClick={onToggleGiftCardModalClick}
          onKeyPress={onToggleGiftCardModalClick}
          data-test-id={testId('giftCardPromoArea')}>
          <Row>
            <RowSpan span="10">
              Gift cards &amp; promotional codes
            </RowSpan>
            <RowSpan span="2">
              <div className={styleRightArrow}>
                {
                  showGiftCardModal
                    ? <ExpandLess color="black" size={24}/>
                    : <ExpandMore color="black" size={24}/>
                }
              </div>
            </RowSpan>
          </Row>
        </h4>
      </Row>

      <Row desktopOnly={true}>
        <div
          role="link"
          tabIndex="0"
          onClick={onToggleGiftCardModalClick}
          data-test-id={testId('giftCardPromoArea')}>
          <Row>
            <RowSpan desktopSpan={withOffset ? '4' : '0'}>
              &nbsp;
            </RowSpan>
            <RowSpan desktopSpan={withOffset ? '7' : '12'}>
              {
                showGiftCardModal
                  ? <ExpandLess color="black" size={24}/>
                  : <ExpandMore color="black" size={24}/>
              }
                Add a gift card or promotion code
            </RowSpan>
          </Row>
        </div>
      </Row>

      {
        showGiftCardModal
          ? <Row>
            <RowSpan mobileSpan="0" desktopSpan={withOffset ? '4' : '0'}>&nbsp;</RowSpan>
            <RowSpan mobileSpan="12" desktopSpan={withOffset ? '8' : '12'}>
              <Row extraClass={css.form}>
                <form method="post" onSubmit={onGiftCardVerify}>
                  <RowSpan span="6">
                    <div { ...textfieldFocusEvents } className={`${css.formInputWrapper} ${css.solo} ${errorList.length ? css.error : ''}`}>
                      <TextField
                        value={code}
                        type="text"
                        name="code"
                        onChange={onGiftCardChange}
                        className={css.formInputField}
                        placeholder="Enter code"
                        data-test-id={testId('giftCardCodeInput')}/>
                    </div>
                  </RowSpan>
                  <RowSpan span="5" isLast={true}>
                    <button
                      type="submit"
                      onClick={onGiftCardVerify}
                      className={css.checkoutSecondaryButton}
                      data-test-id={testId('giftCardCodeSubmit')}
                      disabled={isFetchingCheckoutData}>
                      Apply
                    </button>
                  </RowSpan>
                </form>
              </Row>
              {
                !errorList.length
                  ? null
                  : <Row withPadding={true} data-test-id={testId('giftCardErrorList')}>
                    <RowSpan mobileSpan="12" desktopSpan="9">
                      <ErrorList errorList={errorList} />
                    </RowSpan>
                  </Row>
              }
            </RowSpan>
          </Row>
          : null
      }
    </div>
  );
  /* eslint-enable jsx-a11y/click-events-have-key-events */
};

GiftCardContainer.contextTypes = {
  testId: PropTypes.func
};

export default GiftCardContainer;
